import { Checkbox, Modal } from 'antd';
import React, { useState } from 'react';
import useUtil from '../../../../hooks/useUtil';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/rootReducer';
import { useTranslation } from 'react-i18next';

type AIProofreadingGuidePropTypes = {
  isOpen: boolean,
  setIsOpen: (isOpen: boolean) => void,
  onProofreadExecute: () => void
}

const AIProofreadingGuide = ({
                               isOpen,
                               setIsOpen,
                               onProofreadExecute
                             }: AIProofreadingGuidePropTypes) => {

  const { setCookie } = useUtil();
  const { auth } = useSelector((state: RootState) => state.auth);
  const [isCheck, setIsCheck] = useState<boolean>(false);
  const { t, i18n } = useTranslation();
  const onProofreadExecuteMiddleware = () => {
    if (isCheck) {
      setCookie(auth.memberCode, 'aiProofreadGuide', 1);
    }
    onProofreadExecute();
    setIsOpen(false);
  }

  return (
    <Modal
      title={t('class.tutor.title3')}
      open={isOpen}
      onCancel={() => setIsOpen(false)}
      footer={[
        <>
          <button type="button" className="ant-btn ant-btn-primary" onClick={onProofreadExecuteMiddleware}>
            <span>{t('common.option.yes')}</span>
          </button>
          <button type="button" className="ant-btn ant-btn-default" onClick={() => setIsOpen(false)}>
            <span>{t('common.option.no')}</span>
          </button>
          <div className="modal-today-check">
            <Checkbox onChange={e => setIsCheck(e.target.checked)} checked={isCheck} >{t('class.tutor.button6')}</Checkbox>
          </div>
        </>
      ]}
    >
      <div className="info-text">
        {
          t('class.tutor.message5')
        }
      </div>
    </Modal>
  )
}

export default AIProofreadingGuide;